import { z } from 'zod'
import { groupTagSchema } from './group-tag.schema'

export const createGroupSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters').max(100),
  description: z.string().max(500).optional(),
  tag: groupTagSchema.optional(),
})

export type CreateGroupDto = z.infer<typeof createGroupSchema>
